var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "41px",
    height: "121px",
    viewBox: "0 0 41 121",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A7CEABF6-8A48-4155-ADC8-6732E20AB5CE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.32409775,0.403199961 L33.6680043,0.403199961 C37.6762658,0.403199961 40.9256036,3.65253785 40.9256036,7.66079926 C40.9256036,7.98620964 40.9037179,8.31125163 40.8600947,8.63372477 L30.7149585,83.6289175 C30.2280322,87.2283887 27.155125,89.9135913 23.5228681,89.9135913 L18.6385995,89.9135913 C15.0124607,89.9135913 11.9427557,87.2371825 11.4486839,83.6448607 L1.13418215,8.64966794 C0.588045056,4.6787872 3.36434833,1.01702075 7.33522907,0.470883661 C7.66292439,0.425813919 7.99331759,0.403199961 8.32409775,0.403199961 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VB--404",
    transform: "translate(-705.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(521.000000, 241.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(183.550001, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.979115, 100.359946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5728886,19.9303388 C5.29345181,20.0422897 0.921908829,15.8536907 0.808592755,10.5728886 C0.696641936,5.29345181 4.88524089,0.921908829 10.166043,0.808592755 C15.4454798,0.696641936 19.8170228,4.88524089 19.9303388,10.166043 C20.0436549,15.446845 15.8536907,19.818388 10.5728886,19.9303388 Z",
    id: "Fill-15",
    fill: "#506C94",
    transform: "translate(10.369492, 10.369466) rotate(1.000000) translate(-10.369492, -10.369466) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4194171,18.7787535 C8.13998031,18.8907043 3.76843734,14.7021054 3.65512126,9.4213033 C14.8466986,18.7538402 22.6635513,3.73365556 22.7768673,9.01445763 C22.8901834,14.2952597 18.7002192,18.6668027 13.4194171,18.7787535 Z",
    id: "Fill-15",
    fill: "#3B577E",
    transform: "translate(13.217117, 13.318268) rotate(-44.000000) translate(-13.217117, -13.318268) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63481987,11.5939667 C2.26483606,11.5939667 1.96038445,11.2977066 1.95219292,10.9263576 C1.8907565,8.11529978 2.73311815,5.78208087 4.38644062,4.1792728 C6.02201479,2.59148252 8.34977268,1.83240135 11.1034898,1.97438775 C11.4802999,1.99486656 11.7683684,2.31570123 11.7492549,2.6925113 C11.7287761,3.06795613 11.4161329,3.35192894 11.0311313,3.3382764 C8.66651159,3.20857728 6.69371971,3.84342034 5.33665733,5.1595251 C3.96321191,6.4920129 3.26420192,8.47572681 3.31744682,10.896322 C3.32563834,11.273132 3.02664774,11.5857752 2.64983766,11.5939667 L2.63481987,11.5939667 Z",
    id: "Fill-17",
    fill: "#91A0B4",
    transform: "translate(6.849605, 6.775769) rotate(1.000000) translate(-6.849605, -6.775769) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#506C94",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0771408,0 L43.1858518,0 L29.8647857,91.4510125 L12.310857,91.4510125 C20.383331,74.2567346 25.5291634,58.8258623 27.7483544,45.1583956 C29.9675453,31.490929 31.0771408,16.4381304 31.0771408,0 Z",
    fill: "#3B577E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.79498801,10.4152489 C3.40425236,10.4152489 3.0585701,10.1350989 2.98976131,9.73699084 C2.96436758,9.59282004 2.3991525,6.17695499 4.41672459,3.81206233 C5.64545303,2.37363091 7.52295007,1.65851096 9.99105592,1.69619197 C10.4440471,1.70274519 10.8052933,2.07464033 10.7987401,2.52763154 C10.7921869,2.9798036 10.405547,3.33777316 9.96811966,3.33449655 C8.02509043,3.3009113 6.5661802,3.82353046 5.66920844,4.86876878 C4.14968095,6.64059519 4.59939555,9.43062788 4.60431047,9.45929821 C4.67885333,9.90409791 4.37986274,10.3275996 3.93424389,10.4029617 C3.88755221,10.4111532 3.84086053,10.4152489 3.79498801,10.4152489",
    id: "Fill-6",
    fill: "#91A0B4",
    transform: "translate(6.848429, 6.055013) rotate(1.000000) translate(-6.848429, -6.055013) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1049487,3.40213118 C12.6593299,3.40213118 12.293988,3.04416163 12.2857965,2.59690448 C12.2784241,2.14473242 12.6388511,1.77119897 13.0910232,1.7638266 L15.6836402,1.71959238 C16.1095993,1.69583696 16.5085265,2.07264701 16.516718,2.52481908 C16.5240904,2.97699114 16.1636634,3.35052459 15.7114913,3.35789696 L13.1196935,3.40213118 L13.1049487,3.40213118 Z",
    id: "Fill-8",
    fill: "#91A0B4",
    transform: "translate(14.401257, 2.560329) rotate(1.000000) translate(-14.401257, -2.560329) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.d37f41a977ef9157dec62b3346360bc4.svg";
export { ForwardRef as ReactComponent };